import React, { useState, useRef } from "react";
import Navbar from "./Navbar";
import { useNavigate } from "react-router-dom";
import { useCart } from "./CartContext";
import Care from "./Care";
import { fetchRandomQuote } from "./service/quotesApi";
import SEO from "../components/SEO";

export default function ChestAbdomen() {
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const toastRef = useRef(null);
  const [currentQuote, setCurrentQuote] = useState("Loading quote...");
  const service = {
    id: 6,
    name: "Chest & Abdomin",
    price: "2,999",
    originalPrice: "4,275",
    duration: "45 Min",
    image: "assets/assets/img/CHEST.png",
  };
  const handleAddToCart = async () => {
    // Add to cart first
    addToCart(service);

    try {
      // Fetch new quote
      const quoteData = await fetchRandomQuote();
      setCurrentQuote(quoteData.fullQuote);
    } catch (error) {
      setCurrentQuote("Looking great!");
    }

    // Show toast
    const toast = new window.bootstrap.Toast(toastRef.current);
    toast.show();
  };

  const handleBuyNow = async () => {
    // Add to cart first
    addToCart(service);

    try {
      // Fetch new quote
      const quoteData = await fetchRandomQuote();
      setCurrentQuote(quoteData.fullQuote);
    } catch (error) {
      setCurrentQuote("Looking great!");
    }

    // Navigate to checkout page
    navigate("/checkout");
  };

  return (
    <div
      className=" min-vh-100"
      style={{ fontFamily: "'Inter', sans-serif", backgroundColor: "#8dcae4" }}
    >
      <SEO
        title="Chest & Abdomen Laser Hair Removal | FlawSkin"
        description="Get smooth, hair-free chest and abdomen skin with FlawSkin's safe and effective laser hair removal treatment. Book your session today."
        canonical="https://flawskin.com/chest-abdomen"
      />
      <Navbar />
      <main className="container py-5">
        <div className="card border-0 shadow-sm rounded-4 p-4 p-md-5 bg-white mb-3">
          <div className="row align-items-center g-4">
            <div className="col-auto d-none d-sm-block">
              <div className="p-3 bg-primary-subtle rounded-4 text-primary">
                <img
                  src="assets/assets/img/chest and abdomen.png"
                  alt="Face Category Icon"
                  style={{
                    width: "48px",
                    height: "48px",
                    objectFit: "contain",
                  }}
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              </div>
            </div>
            <div className="col">
              <h1 className="h3 fw-bold text-dark mb-2">Chest & Abdomen</h1>
              <p
                className="text-secondary mb-0 border-start border-3 ps-3 py-1"
                style={{ fontSize: "15px", maxWidth: "700px" }}
              >
                Get smooth, hair-free skin on your Chest&Abdomin with our safe
                and effective laser hair removal treatments.
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card border-light-subtle shadow-sm rounded-3 bg-white p-4 h-100 d-flex flex-column justify-content-between">
              <div>
                {/* Top Heading Group */}
                <div className="d-flex justify-content-between align-items-start gap-2 mb-3">
                  <h3 className="h6 fw-bold text-dark mb-0 mt-1">
                    {service.name}
                  </h3>
                  <div className="d-flex gap-1 flex-shrink-0">
                    {service.image && (
                      <img
                        src={service.image}
                        className="rounded-3 border border-light-subtle object-fit-cover"
                        alt={service.name}
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "20px",
                        }}
                        onError={(e) => {
                          e.target.style.display = "none";
                        }}
                      />
                    )}
                  </div>
                </div>

                {/* Trust Badge Rating */}
                <div className="d-flex align-items-center gap-2 mb-3 small">
                  <div className="text-warning">
                    <i className="fa fa-star me-1"></i>
                    <span className="fw-bold text-dark">5.0</span>
                  </div>
                  <a
                    href="https://www.google.com/search?hl=en-IN&amp;gl=in&amp;q=Flawskin+pvt+Ltd..."
                    className="text-muted text-decoration-none border-start ps-2"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    (234 Verified Reviews)
                  </a>
                </div>

                {/* Core Timing Specs */}
                <div className="d-flex align-items-center gap-2 mb-4 text-secondary small bg-light p-2 rounded-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    fill="currentColor"
                    className="bi bi-clock text-primary"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.433l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z" />
                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0" />
                  </svg>
                  <span>
                    Est. Treatment Window: <strong>{service.duration}</strong>{" "}
                    per session
                  </span>
                </div>
              </div>

              {/* Pricing & Checkout Block */}
              <div className="mt-auto pt-3 border-top border-light-subtle">
                <div className="d-flex align-items-baseline justify-content-between mb-3">
                  <span className="text-muted small">Package Price</span>
                  <div className="text-end">
                    <del className="text-muted small me-2">
                      ₹{service.originalPrice}
                    </del>
                    <span className="h4 fw-bold text-primary mb-0">
                      ₹{service.price}
                    </span>
                  </div>
                </div>

                {/* Utility Support Modals Links */}
                <div className="mb-3">
                  <a
                    href="#"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    className="text-decoration-none small text-secondary d-inline-flex align-items-center gap-1 bg-light px-2.5 py-1 rounded-2 border"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      fill="currentColor"
                      className="bi bi-journal-medical text-primary"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5"
                      />
                      <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m0 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z" />
                    </svg>
                    Pre & Post Care Directive
                  </a>
                </div>

                {/* Primary CTA Elements */}
                <div className="row g-2">
                  <div className="col-6">
                    <button
                      className="btn btn-outline-primary w-100 py-2 fw-semibold rounded-3 text-uppercase small"
                      style={{ fontSize: "12px", letterSpacing: "0.5px" }}
                      onClick={handleAddToCart}
                    >
                      Add to Cart
                    </button>
                  </div>
                  <div className="col-6">
                    <button
                      className="btn btn-primary w-100 py-2 fw-semibold rounded-3 text-uppercase small shadow-sm"
                      style={{ fontSize: "12px", letterSpacing: "0.5px" }}
                      onClick={handleBuyNow}
                    >
                      Buy Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Care />
      <div className="toast-container position-fixed bottom-0 end-0 p-3">
        <div
          ref={toastRef}
          className="toast"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          data-bs-autohide="true"
          data-bs-delay="3000"
        >
          <div className="toast-body">
            <div className="d-flex gap-4">
              <span>
                <i className="fa-solid fa-circle-check fa-lg text-success"></i>
              </span>
              <div className="d-flex flex-column flex-grow-1 gap-2">
                <div className="d-flex align-items-center">
                  <span className="fw-semibold">Item added to cart!</span>
                  <button
                    type="button"
                    className="btn-close btn-close-sm ms-auto"
                    data-bs-dismiss="toast"
                    aria-label="Close"
                  ></button>
                </div>
                <p className="mb-0 small text-muted fst-italic">
                  {currentQuote}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="mt-4 p-4 rounded-lg border border-primary-100 bg-gradient-to-r from-light-50 to-light-100 shadow-sm"
        style={{ backgroundColor: "rgba(211, 211, 211, 0.8)" }}
      >
        <div className="d-flex align-items-center mb-3">
          <span className="bg-primary-100 text-white p-2 rounded-circle me-3">
            <i className="fas fa-shield-alt fs-5"></i>{" "}
            {/* Protection/confidence icon */}
          </span>
          <h5 className="text-primary mb-0">
            <span className="border-bottom border-3">
              Defined Chest & Abdomen
            </span>
          </h5>
        </div>

        <p className="lead fs-6 text-primary">
          <span className="text-primary">Show off</span> your contours with{" "}
          <strong>permanent hair reduction</strong> – perfect for athletes,
          swimmers, or anyone wanting a cleaner look.
          <span className="d-block mt-1">
            No more{" "}
            <span className="text-decoration-line-through text-muted">
              patchy shaving
            </span>{" "}
            or uncomfortable waxing!
          </span>
        </p>

        <div className="row mt-3 g-3">
          <div className="col-md-6">
            <div className="p-3 bg-white rounded shadow-sm h-100">
              <div className="d-flex align-items-start">
                <span className="badge bg-primary-soft text-primary rounded-pill me-2">
                  ✓
                </span>
                <div>
                  <h6 className="mb-1">Enhanced Definition:</h6>
                  <p className="small text-muted mb-0">
                    Accentuate muscle tone with hair-free skin.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-3 bg-white rounded shadow-sm h-100">
              <div className="d-flex align-items-start">
                <span className="badge bg-primary-soft text-primary rounded-pill me-2">
                  ✓
                </span>
                <div>
                  <h6 className="mb-1">Pro Tip:</h6>
                  <p className="small text-muted mb-0">
                    Avoid sun exposure for 1 week before/after treatment.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-3 text-center">
          <button className="btn btn-primary btn-sm rounded-pill px-4">
            <i className="fas fa-bolt me-2"></i>Find the hair reduction from the
            1st session.
          </button>
        </div>
      </div>
    </div>
  );
}
